import { render, staticRenderFns } from "./FiltroDeBusca.vue?vue&type=template&id=f49d9fda"
import script from "./FiltroDeBusca.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltroDeBusca.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports